import React, { useCallback } from 'react';
import ReportHeader from '../../components/reports/shared/report-header';
import PersonalityAcumenResults from '../../components/reports/shared/results/personality-acumen-results';
import ExperienceJudgmentResults from '../../components/reports/shared/results/experience-judgment-results';
import ValuesFitResults from '../../components/reports/shared/results/values-fit-results';
import CompetenciesJudgmentTips from '../../components/reports/shared/tips/competencies-judgment-tips';
import { LEADER_VALUE_TIPS } from '../../components/reports/shared/tips/acumen-values-experience-tips';
import RecommendationsPersonalityTips from '../../components/reports/shared/tips/recommendations-personality-tips';
import ReportPdfHeader from '../../components/reports/shared/report-pdf-header';
import LeaderReportSummary from '../../components/reports/leader/leader-report-summary';
import LeaderCompetenciesStrengthsWeaknesses from '../../components/reports/leader/leader-competencies-alignment-strengths-weaknesses';
import LeaderManagerCoachingTipsIntro from '../../components/reports/leader/leader-manager-coaching-tips-intro';
import PagedAcumenValuesExperienceTips from '../../components/reports/shared/tips/paged-acumen-values-experience-tips';
import LeaderCompetenciesSummary from '../../components/reports/leader/leader-competencies-summary';
import { generateCompetenciesCommentsPdfPages } from '../../components/reports/shared/report-util';
import LeaderConfidentialPage from '../../components/reports/leader/leader-confidential-page';
import LeaderInstructionsPage1 from '../../components/reports/leader/leader-instructions-page-1';
import LeaderInstructionsPage2 from '../../components/reports/leader/leader-instructions-page-2';
import { REPORT_TYPE } from '../../utils/constants';
import { FeedbackReport } from '../../components/reports/shared/results/feedback-report';

function LeaderManagerReport({ candidate, creatingPdf, withSummary = false }) {
  const openEndedCommentsPages = useCallback(() => {
    return generateCompetenciesCommentsPdfPages(creatingPdf, candidate);
  }, [candidate, creatingPdf]);

  return (
    <>
      <div className="print-page">
        <LeaderConfidentialPage candidate={candidate} />
      </div>
      <div className="print-page">
        <LeaderInstructionsPage1 />
      </div>
      <div className="print-page">
        <LeaderInstructionsPage2 />
      </div>
      <FeedbackReport candidate={candidate} reportType={REPORT_TYPE.development} creatingPdf={creatingPdf} />
      {withSummary && (
        <div className="print-page print-heading">
          <ReportPdfHeader />
          <ReportHeader candidate={candidate} header="Leader's Manager Report" />
          <LeaderReportSummary candidate={candidate} speedometers={true} reportType={REPORT_TYPE.development} />
        </div>
      )}
      <div className="print-page">
        <PersonalityAcumenResults candidate={candidate} reportType={REPORT_TYPE.development} />
      </div>
      <div className="print-page">
        <ValuesFitResults candidate={candidate} reportType={REPORT_TYPE.development} />
      </div>
      <div className="print-page">
        <ExperienceJudgmentResults candidate={candidate} reportType={REPORT_TYPE.development} />
      </div>
      <div className="print-page">
        <LeaderCompetenciesSummary candidate={candidate} />
      </div>
      <div className="print-page">
        <LeaderCompetenciesStrengthsWeaknesses candidate={candidate} withComments={!creatingPdf} />
      </div>
      {openEndedCommentsPages()}
      <div className="print-page">
        <RecommendationsPersonalityTips
          candidate={candidate}
          withAcumen={true}
          tipsIntro={<LeaderManagerCoachingTipsIntro />}
          reportType={REPORT_TYPE.development}
        />
      </div>
      <PagedAcumenValuesExperienceTips
        candidate={candidate}
        valuesTips={LEADER_VALUE_TIPS}
        withAcumen={false}
        topFourMisAligned={true}
        creatingPdf={creatingPdf}
        reportType={REPORT_TYPE.development}
      />
      <div className="print-page">
        <CompetenciesJudgmentTips candidate={candidate} nTips={1} reportType={REPORT_TYPE.development} />
      </div>
    </>
  );
}

export default LeaderManagerReport;
